import React from 'react';
import ReactDOM from 'react-dom';
import { ShowContextProvider } from './context/showContext.js';
import App from './App.js';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <ShowContextProvider>
      <App />
    </ShowContextProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js